var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.82,
    height: 22.527,
    viewBox: "0 0 21.82 22.527",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "whats-app_17291516",
    transform: "translate(-2.943 -1.947)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42565",
    "data-name": "Path 42565",
    d: "M2.968,23.963a.375.375,0,0,0,.35.511.384.384,0,0,0,.087-.01l6.306-1.507a10.919,10.919,0,1,0-4.84-3.906Zm.725-11.1a10.141,10.141,0,1,1,6.2,9.351.375.375,0,0,0-.234-.02L3.926,23.567l1.718-4.433A.375.375,0,0,0,5.6,18.78a10.08,10.08,0,0,1-1.906-5.913Z",
    transform: "translate(0 0)",
    fill: "#8f768f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42566",
    "data-name": "Path 42566",
    d: "M17.509,21.784a10.271,10.271,0,0,0,4.075,4.861A7.616,7.616,0,0,0,23,27.305a2.641,2.641,0,0,0,.861.145A2.934,2.934,0,0,0,26.1,26.341l1.215-1.449a.445.445,0,0,0,0-.551l-2.394-2.855a.3.3,0,0,0-.462,0l-1.627,1.94A6.823,6.823,0,0,1,20.208,20.3l1.627-1.94a.445.445,0,0,0,0-.551l-2.394-2.855a.3.3,0,0,0-.462,0l-1.215,1.449a4.271,4.271,0,0,0-.81,3.692,11.145,11.145,0,0,0,.556,1.685Zm.719-4.828.981-1.173,1.932,2.3-1.561,1.86a.447.447,0,0,0-.065.439,7.518,7.518,0,0,0,3.242,3.865.289.289,0,0,0,.368-.078l1.56-1.861,1.932,2.3-.984,1.173a2.231,2.231,0,0,1-2.455.766,7.036,7.036,0,0,1-1.3-.608,9.539,9.539,0,0,1-3.783-4.511,10.283,10.283,0,0,1-.51-1.553,3.384,3.384,0,0,1,.643-2.927Z",
    transform: "translate(-7.844 -8.284)",
    fill: "#8f768f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWhatsapp);
export default __webpack_public_path__ + "static/media/icon-whatsapp.bd5d239766a678e9544193e309438d57.svg";
export { ForwardRef as ReactComponent };